export enum PalantirEmptyStateSizeEnum {
  'large' = 'large',
  'small' = 'small',
}

export type PalantirEmptyStateSize = keyof typeof PalantirEmptyStateSizeEnum;
